import QuizForm from './QuizForm';
export default QuizForm;